<div class="teach-all-list">
  <app-lessons-list
    [lessonStatus]="lesson_statuses.LESSON_CREATED"
    [showHeader]="false"
    [onlyStatuses]="[lesson_statuses.LESSON_CREATED, lesson_statuses.LESSON_IN_WORK]">
  </app-lessons-list>
</div>
